import qs from 'qs';

import fetch from '@giro/shared-utils/fetch.util';

export default async function getApiPaymentLinksService(filters: any = {}) {
  const filtersStringfy = qs.stringify(filters, { skipNulls: true });
  const url = ['payment-links', filtersStringfy].join('?');

  return fetch(url, {
    method: 'GET',
    ms: 'PDV',
    auth: true,
  });
}
